import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import DayPicker from './DayPicker';
import TodayPicker from './TodayPicker';
import css from './Calendar.scss';
import moment from 'moment';
import IconPath from 'src/utils/IconPath';

class Calendar extends React.Component {
	render() {
		return (
			<div data-cwid={this.props.cwId} className={css.calendar} style={this.props.style} 
        onMouseDown={this.props.onMouseDown} 
        onMouseUp={this.props.onMouseUp} 
        ref={(div) => this.div = div}>
				<Header value={this.props.value} monthName={this.props.monthName} leftArrow={this.props.leftArrow}
					rightArrow={this.props.rightArrow} onChange={this.props.onChange} onClick={this.props.onHeaderClick} />
				<DayPicker value={this.props.value} onChange={this.props.onChange} daysOfTheWeek={this.props.daysOfTheWeek} isDateTime={this.props.isDateTime} />
				<TodayPicker onChange={this.props.onChange} value={this.props.localToday} isDateTime={this.props.isDateTime} />
			</div>
		);
	};
};

Calendar.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
	cwId: PropTypes.string,
  /**
   * A working instance of a moment Object. Note that this value is not the same as the "value" displayed in the
   * DatePicker's text field but instead should represent the date associated with the state in CwDatePicker.
   */
	value: PropTypes.instanceOf(moment),
  /**
   * An array of localized months
   */
	monthName: PropTypes.arrayOf(PropTypes.string),
  /**
   * An array of localized days of the week
   */
	daysOfTheWeek: PropTypes.arrayOf(PropTypes.string),
  /**
   * The localized version of the word today
   */
	localToday: PropTypes.string,
  /**
   * A function to handle updating the text field should at least update the value
   */
	onChange: PropTypes.func,
  /**
   * url for the left arrow image
   */
	leftArrow: PropTypes.string,
  /**
   * url for the right arrow image
   */
	rightArrow: PropTypes.string,
  /**
   * A function responsible for handling the arrow clicks in the header
   */
	onHeaderClick: PropTypes.func,
  /**
   * A function to handle mouse down events, useful for tracking when someone clicks off the calendar
   */
	onMouseDown: PropTypes.func,
  /**
   * A function to handle the mouse up event, useful for tracking when someone clicks off the calendar
   */
	onMouseUp: PropTypes.func,
  /**
   * Set of style properties to determine the calendar's position. Must contain left and top
   */
	style: PropTypes.shape({
		left: PropTypes.number,
		top: PropTypes.number
	}),
};

Calendar.defaultProps = {
  leftArrow: IconPath.get('Action_Back'),
  rightArrow: IconPath.get('Action_Forward')
};

export default Calendar;


// WEBPACK FOOTER //
// ./src/components/cwdatepicker/Calendar.jsx